<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-配送设置-修改
    -->
    <el-dialog
    title="修改配送设置"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
    :append-to-body="true"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="配送设置名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入配送设置名称" class="max-w460"></el-input>
          </el-form-item>

      <el-form-item label="配送司机" prop="u">
                 
        <el-button @click="openGetuser('driver')" icon="el-icon-plus">选择司机</el-button>
          <div>  姓名：{{ user.nickName?user.nickName:"还未选择" }}</div>

      </el-form-item>  

      <el-form-item label="司机每单/元" prop="driver_order" >
            <el-input v-model="form.driver_order" placeholder="请输入司机每单/元" 
            style="width: 200px;"
            class="max-w460"></el-input>
          </el-form-item>


      <el-form-item label="最低起送金额" prop="min_delivery_price" >
            <el-input v-model="form.min_delivery_price" placeholder="请输入最低起送金额" 
            style="width: 200px;"
            class="max-w460"></el-input>
          </el-form-item>

          <el-form-item label="配送时间段设置" >
        <el-button size="small" type="primary" @click="addSetting" >新增配送时间段设置</el-button>
        <el-table :data="form.setting"  border size="mini" style="width: 100%;margin-top: 20px;">
   

            <el-table-column prop="name" label="标签名称"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-select id="searchType" v-model="scope.row.dates" class="searchType">
                      <el-option  label="周一" value="1"></el-option>
                      <el-option  label="周二" value="2"></el-option>
                      <el-option  label="周三" value="3"></el-option>
                      <el-option  label="周四" value="4"></el-option>
                      <el-option  label="周五" value="5"></el-option>
                      <el-option  label="周六" value="6"></el-option>
                      <el-option  label="周日" value="7"></el-option>     
                  </el-select>
                </div>
              </template>
            </el-table-column>    
            
            <el-table-column prop="name" label="选择开始时间"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-time-picker
                      v-model="scope.row.times_one"
                      start-placeholder="时间"
                      placeholder="选择开始时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      >
                    </el-time-picker>
                </div>
              </template>
            </el-table-column> 


            <el-table-column prop="name" label="选择结束时间"   width="200" >
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-time-picker
                      v-model="scope.row.times_two"
                      start-placeholder="时间"
                      placeholder="选择结束时间"
                      format="HH:mm"
                      value-format="HH:mm"
                      >
                    </el-time-picker>
                </div>
              </template>
            </el-table-column> 



            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delSetting(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item> 



      <el-form-item label="配置固定线路" prop="fix_line" >
        <div style="margin-bottom: 20px;">
          <el-button @click="warehouseClick" icon="el-icon-plus">选择仓库</el-button>
          <el-button @click="storeClick" icon="el-icon-plus">选择门店</el-button>
        

        </div>
       
        <el-table  :data="form.line_store" style="width: 100%;max-height: 500px;overflow-y: auto;" border>

          <!-- 仓库名称 -->
          <el-table-column prop="name" label="名称" ></el-table-column>
          <!-- 仓库地址 -->
          <el-table-column prop="address" label="地址"></el-table-column>
          <!-- 仓库经纬度 -->
          <el-table-column label="经纬度" >
            <template slot-scope="scope">
              <span>纬度: {{ scope.row.latitude }}</span><br />
              <span>经度: {{ scope.row.longitude }}</span>
            </template>
          </el-table-column>
          <!-- 仓库类型 -->
          <el-table-column prop="type" label="类型" >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1">仓库</span>
              <span v-else-if="scope.row.type === 2">门店</span>
              <span v-else-if="scope.row.type === 3">司机</span>

            </template>
          </el-table-column>  

          <el-table-column label="距离" >
            <template slot-scope="scope">
              <span v-if="scope.row.distance && scope.row.distance > 0">{{ scope.row.distance }}km</span><br />

            </template>
          </el-table-column>

          <el-table-column label="预估时长" >
            <template slot-scope="scope">
              <span v-if="scope.row.stimated && scope.row.stimated > 0"> {{ scope.row.stimated }}分钟</span><br />

            </template>
          </el-table-column>



          <el-table-column prop="type" label="作为起点" >
            <template slot-scope="scope">
              <el-switch v-if="scope.row.type != 2" v-model="scope.row.start" active-color="#13ce66" 
              inactive-color="#ff4949"  @change="isDefaultChange(scope.row)"
              active-text="是" inactive-text="否"  :active-value="1" :inactive-value="0"></el-switch>
         
            </template>
          </el-table-column>   


          <el-table-column prop="type" label="操作" >
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="delx(scope.$index)">删除</el-button>

            </template>
          </el-table-column>

          </el-table> 

          <div style="font-weight: 600;font-size: 16px;">请先保存途径点  再生成路线</div>

          <el-button size="small" type="primary" @click="saveLineStore">保存途径点</el-button>
          <el-button @click="generate" icon="el-icon">生成固定路线</el-button>


      </el-form-item>

      <el-form-item label="预估总费用" prop="total_price" >
            {{ form.total_price }}

            <div>具体费用请在发货单修改</div>
          </el-form-item>


      <el-form-item label="固定线路" prop="fix_line" >
        <div id="map-container"  style="width:100%; height:600px"></div>


      </el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>

     
        
      </div>
    </el-form>
  
    <GetInsUser :is_open="open_cm" :code="code" :multi="false"   @close="closeCm"></GetInsUser>

    <!-- <Dates :is_open="open_dates" :selectData="form.delivery_date"  :multi="multidates"   @close="closeDates"></Dates> -->
    <Maps v-if="open_maps" :open_add="open_maps" :store_ll="store_ll"  @closeDialog="closeDialogFunc($event, 'kmd')"></Maps>
    <Store v-if="open_store" :is_open="open_store" :selectlist="selectlist" :multi="multi"  @closex="closeDialogStore($event)"></Store>
    <Warehouses v-if="open_warehouse" :is_open="open_warehouse" :selectlist="selectwarehouse" :multi="false"  
    @closex="closeDialogWarehouse($event)"></Warehouses>

  </div>
</el-dialog>
  
</template>

<script>
import LineApi from '@/api/line.js';
import OrderApi from '@/api/order.js';
import GetInsUser from '@/components/user/getInsUser.vue';
import Dates from '@/components/user/dates.vue';
import Maps from '@/components/map/maps.vue';
import Store from '@/components/store/Stores.vue';
import Warehouses from '@/components/select/warehouses.vue';


import {mergeTable} from '@/utils/table.js'
import { unset } from 'lodash';
export default {
  components: {
    GetInsUser,
    Dates,
    Maps,
    Store,
    Warehouses,
  },
  data() {
    return {
      multi:true,
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否上传图片*/
      isupload: false,
      /*form表单数据*/
      form: {
        user_id:0,
        name:"",
        time_period:"",
        min_delivery_price:"",
        first_order_delivery_price_free:"",
        first_order_delivery_price_no:"",
        other_order_delivery_price_free:"",
        other_order_delivery_price_no:"",
        delivery_date:[],
        is_default:0,
        driver_order:0,

        line_store:[]
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入配送设置名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      open_cm:false,
        code:"",
        user:{

      },
      multidates:true,
      open_dates:false,
      open_maps:false,



  
      open_store:false,
      selectlist:[],

      open_warehouse:false,
      selectwarehouse:[],


      obj:{
        id:0,
        type:1,
        name:"",
        address:"",
      }

    };
  },
  created() {
    var self  =this;
    self.dialogVisible = this.open_add;
    self.getDetail();

  },
  props: ["open_add","line_id"],
  mounted(){
     // 地图初始化代码
     const script = document.createElement('script');
      script.src = 'https://webapi.amap.com/maps?v=1.4.15&key=16e7503e2bdb0605334458a3d3bd1f02';
      script.async = true;
      document.head.appendChild(script);
  },
  methods: {


     // 生成发货单
     generate() {
        let self = this;

   
          if(this.form.line_store.length <= 0){
            self.$message.error('请选择门店/仓库');
            return;
          }
          var ind = 0;
          for(var i=0;i<this.form.line_store.length;i++){
              if(this.form.line_store[i].type == 1){
                ind++;
              }
          }
          
          if(ind <= 0){
            self.$message.error('请至少选择一个仓库');
            return;
          }



          var ind1 = 0;
          for(var i=0;i<this.form.line_store.length;i++){
              if(this.form.line_store[i].type == 1 && this.form.line_store[i].start == 1){
                ind1++;
              }
          }
          
          if(ind1 <= 0){
            self.$message.error('请至少选择一个起点');
            return;
          }

        self
          .$confirm('是否生成固定线路?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            OrderApi.genFixedLine(
              {
                line_store:JSON.stringify(self.form.line_store),
                line_id:self.line_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '生成成功',
                    type: 'success'
                  });
                  self.getDetail();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
        /*创建图表对象*/
   initMap() {
      let that = this;
        that.map = new AMap.Map("map-container", {
          resizeEnable: true,
          zoom: 7,
          center: that.form.linex[0] //地图中心点
        });
        AMap.plugin(["AMap.ToolBar"], function() {
          //加载工具条
          var tool = new AMap.ToolBar();
          that.map.addControl(tool);
        });
        //清除地图的所有覆盖物
        that.map.clearMap();
        //电池经纬度,也用于画线
        this.markerArr = [];
        //获取数据
        this.GetBatteryHistory();
    },

    //获取轨迹数据
    GetBatteryHistory() {
      let that = this;
      //接口获得数据后转换，高德接受的数据格式为[[111.11,122.22],[111.11,123.33]]
      setTimeout(() => {
        //坐标点数组转换
        var marker = that.form.line.info;//[[116.478935,39.997761],[116.478939,39.997825],[116.478912,39.998549],[116.478912,39.998549],[116.478998,39.998555],[116.478998,39.998555],[116.479282,39.99856],[116.479658,39.998528],[116.480151,39.998453],[116.480784,39.998302],[116.480784,39.998302],[116.481149,39.998184],[116.481573,39.997997],[116.481863,39.997846],[116.482072,39.997718],[116.482362,39.997718],[116.483633,39.998935],[116.48367,39.998968],[116.484648,39.999861]]
        marker.map(ele => {
            let tempArr = [];
            tempArr.push(ele[0]);
            tempArr.push(ele[1]);

            that.markerArr.push(tempArr);
        });
        
        that.$nextTick(() => {
          //画线
          that.playLine();
        });
     
      }, 1000);
    },
    //画线
    playLine() {
      let that = this;
      console.log('that.markerArr',that.markerArr)
      //初始化起点终点
      that.initStartEnd();
   
      that.marker = new AMap.Marker({
        map: that.map,
        //小车出初始位置
        position: that.markerArr[0],
        icon: "https://webapi.amap.com/images/car.png",
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        angle: -90
      });
      for(var i =0;i<that.form.line_store.length;i++){
        var el_i = that.form.line_store[i];
  
        if(el_i.type == 1){
           var ma =  new AMap.Marker({
              map: that.map,
              //小车出初始位置
              position: [el_i.longitude,el_i.latitude],
              icon: "./static/warehouse.png",
      
            });
     
          }else if(el_i.type == 2){
            var ma =  new AMap.Marker({
              map: that.map,
              //小车出初始位置
              position: [el_i.longitude,el_i.latitude],
              icon: "./static/store.png",
      
            });
  
          }

  


                  // 为标记绑定点击事件
                  ma.on('click', (function(el_i, ma) {
                  return function() {
                      // 动态创建 InfoWindow，显示该标记对应的内容
                      var infoWindow = new AMap.InfoWindow({
                          content: `<div>
                                      <strong>${el_i.name}</strong><br>
                                      地址: ${el_i.address}
                                    </div>`,
                          offset: new AMap.Pixel(0, -30) // 偏移量
                      });

                      // 打开当前标记的 InfoWindow
                      infoWindow.open(that.map, ma.getPosition());
                  };
              })(el_i, ma));  // 使用自执行函数立即捕获 el_i 和 ma


      }
  

      // 绘制轨迹
      that.polyline = new AMap.Polyline({
        map: that.map,
        path: that.markerArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 //线宽
        // strokeStyle: "solid"  //线样式
      });
      //自适应放大
      setTimeout(() => {
        that.map.setFitView();
      }, 500);
    },
    //初始化起点终点
    initStartEnd() {
      let that = this;
      //将icon添加进marker
      let startMarker = new AMap.Marker({
        position: new AMap.LngLat(that.markerArr[0][0], that.markerArr[0][1]),
        icon: that.startIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      //将icon添加进marker
      let endMarker = new AMap.Marker({
        position: new AMap.LngLat(
          that.markerArr.pop()[0],
          that.markerArr.pop()[1]
        ),
        icon: that.endIcon,
        offset: new AMap.Pixel(-13, -30)
      });
      // 将 markers 添加到地图
      that.map.add([startMarker, endMarker]);
    },











    isDefaultChange(row){
      this.obj = row;
      this.updStart();
    },
    updStart(){
      var self = this;
      var params = self.obj;
        params.line_id = self.line_id;
        OrderApi.updStart(params
        ).then(data => {
          self.loading = false;
          self.$message({
              message: '修改成功',
              type: 'success'
            });
        })
          .catch(error => {
            self.loading = false;
          });
    },
    saveLineStore(){
      var self = this;
      var params = self.form.line_store;
        for(var i=0;i<params.length;i++){
          params[i].line_id = self.line_id
        }
        OrderApi.saveLineStore({
          'line_store':JSON.stringify(params),
          "line_id":self.line_id
        }
        ).then(data => {
          self.loading = false;
          self.$message({
              message: '保存成功',
              type: 'success'
            });
        })
          .catch(error => {
            self.loading = false;
          });
    },


    storeClick(){
      this.open_store = true;
    },
    closeDialogStore(e){
      let self = this;
  
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            name: item.store_name,
            id:item.store_id,
            latitude:item.latitude,
            longitude:item.longitude,
            address:item.address,
            type:2,//1 仓库  2 门店  3 司机
            start:0,//0 不是起点  1  是起点
          };
          var ind = 0;
          for(var j=0;j<self.form.line_store.length;j++){
              if(self.form.line_store[j].id == item.store_id && self.form.line_store[j].type == 2 ){
                ind++;
              }
          }
          if(ind <= 0){
            arr.push(obj)
          }
         
        }
        if(arr.length > 0){
          self.form.line_store = self.form.line_store.concat(arr);
        self.form.line_store = mergeTable(this.form.line_store);

        }
   
      
      }

      this.open_store = false;
    },

    warehouseClick(){
      this.open_warehouse = true;
    },
    closeDialogWarehouse(e){
      let self = this;
      console.log('e',e);


      if (e.type === 'success') {
        let arr = [];
        e.params = [e.params];
          for (let i = 0; i < e.params.length; i++) {
            let item = e.params[i];
            let obj = {
              name: item.name,
              id:item.warehouse_id,
              latitude:item.latitude,
              longitude:item.longitude,
              address:item.address,
              type:1,//1 仓库  2 门店  3 司机
              start:0,//0 不是起点  1  是起点
            };

            var ind = 0;
            for(var j=0;j<self.form.line_store.length;j++){
                if(self.form.line_store[j].id == item.warehouse_id && self.form.line_store[j].type == 1 ){
                  ind++;
                }
            }
            if(ind <= 0){
              arr.push(obj)
            }
          }
     
          if(arr.length > 0){
            self.form.line_store = self.form.line_store.concat(arr);
            self.form.line_store = mergeTable(this.form.line_store);

            }
   

          this.open_warehouse = false;
      }
    },

    delx(ind){
      this.form.line_store.splice(ind,1);
 
    },
 


    delSetting(index){
        this.form.setting.splice(index,1)
    },
      addSetting(){
        this.form.setting.push({
          dates:'',
          times_one:"",
          times_two:"",

        });
      },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.open_maps = false;
    },
    viewMap(store_ll){
      this.store_ll = store_ll;
        this.open_maps = true;
    },
    openDates(code){
      this.open_dates = true;
    },
    closeDates(e){
      var self = this;
      self.open_dates=false;
      if(e.type == 'success'){
        this.form.delivery_date = e.params
      }
     
    },
    del(index){
      this.form.delivery_date.splice(index,1);
    },


    /*打开获取用户*/
    openGetuser(code) {
      this.open_cm = true;
      this.code = code;
    },
  
    closeCm(e){
      var self = this;
      self.open_cm=false;
      if(e.params && e.params.user_id){
   
        self.form.user_id = e.params.user_id;
        self.user.mobile = e.params.mobile;
        self.user.nickName = e.params.nickName;

      }


    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      LineApi.detail({line_id: self.line_id},true).then(res => {
          self.form = res.data;
          self.loading = false;
          self.user = res.data.user;
          if(!self.form.line_store){
            self.form.line_store = [];
          }
          setTimeout(() => {
            self.initMap();
          },300) 
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      if(form.wx_line){
        delete form.wx_line;
      }
      if(form.line){
        delete form.line;
      }
      if(form.points){
        delete form.points;
      }
      if(form.lines){
        delete form.lines;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          LineApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
 
  }
};
</script>

<style>
.dates{
  height: 30px;line-height: 30px; background: #66B1FF;width: 60px;float: left;margin-right: 10px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  margin-top: 5px;

}
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/line/index/part/edit.vue